(function () {
  function qs(el, sel) {
    return el.querySelector(sel);
  }

  class InfoCellPopup {
    constructor(wrapper) {
      this.wrapper = wrapper;
      this.popup = qs(wrapper, '.info-cell-popup');
      this.trigger = qs(wrapper, '.product-cell-wrapper');
      this.closeBtn = qs(wrapper, '.info-cell-popup-close');
      this.overlay = qs(wrapper, '.info-cell-popup-overlay');
      this.content = qs(wrapper, '.info-cell-popup-content');
      this.header = qs(wrapper, '.info-cell-popup-header');
      this.touchStartY = 0;
      this.touchDiff = 0;
      this.isDragging = false;

      if (!this.popup || !this.trigger || !this.closeBtn || !this.overlay || !this.content || !this.header) {
        return;
      }

      this.trigger.addEventListener('click', (e) => this.open(e));
      this.closeBtn.addEventListener('click', () => this.close());
      this.overlay.addEventListener('click', () => this.close());

      this._touchStart = (e) => {
        if (window.innerWidth > 749) return;
        this.touchStartY = e.touches[0].clientY;
        this.content.style.transition = 'none';
        this.isDragging = true;
      };
      this._touchMove = (e) => {
        if (window.innerWidth > 749 || !this.isDragging) return;
        var touchY = e.touches[0].clientY;
        this.touchDiff = touchY - this.touchStartY;
        if (this.touchDiff > 0) {
          e.preventDefault();
          this.content.style.transform = 'translateY(' + this.touchDiff + 'px)';
        }
      };
      this._touchEnd = () => {
        if (window.innerWidth > 749) return;
        this.content.style.transition = 'all 0.3s ease-out';
        if (this.touchDiff > 100) {
          this.close();
        } else {
          this.content.style.transform = '';
        }
        this.touchDiff = 0;
        this.isDragging = false;
      };

      this.header.addEventListener('touchstart', this._touchStart, { passive: true });
      this.header.addEventListener('touchmove', this._touchMove, { passive: false });
      this.header.addEventListener('touchend', this._touchEnd);
    }

    open(event) {
      event.preventDefault();
      event.stopPropagation();
      /* Append to body so fixed overlay/backdrop covers the full viewport (not clipped by product column / transform ancestors). */
      if (this.popup.parentNode !== document.body) {
        document.body.appendChild(this.popup);
      }
      this.popup.style.display = 'block';
      this.popup.removeAttribute('aria-hidden');
      this.trigger.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => {
        this.popup.classList.add('active');
      });
      document.body.classList.add('overflow-hidden');
    }

    close() {
      this.popup.classList.remove('active');
      this.trigger.setAttribute('aria-expanded', 'false');
      this.popup.setAttribute('aria-hidden', 'true');
      var self = this;
      setTimeout(function () {
        self.popup.style.display = 'none';
        document.body.classList.remove('overflow-hidden');
        self.content.style.transform = '';
        if (self.wrapper && self.popup.parentNode === document.body) {
          self.wrapper.appendChild(self.popup);
        }
      }, 300);
    }
  }

  function initProductInfoCells(root) {
    var scope = root || document;
    scope.querySelectorAll('.product-info-cell-wrapper').forEach(function (wrapper) {
      if (wrapper.dataset.infoCellInit === '1') return;
      wrapper.dataset.infoCellInit = '1';
      wrapper._infoCellPopup = new InfoCellPopup(wrapper);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initProductInfoCells();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initProductInfoCells(event.target);
  });

  document.addEventListener('click', function (e) {
    var active = document.querySelector('.info-cell-popup.active');
    if (!active) return;
    var wrapper = active.closest('.product-info-cell-wrapper');
    if (!wrapper) return;
    var trig = wrapper.querySelector('.product-cell-wrapper');
    if (trig && trig.contains(e.target)) return;
    var content = active.querySelector('.info-cell-popup-content');
    if (content && content.contains(e.target)) return;
    var inst = wrapper._infoCellPopup;
    if (inst) inst.close();
  });
})();
